export class TooltipSystem {
  private el: HTMLElement | null = null;
  private visible = false;

  init(elementId: string): void {
    this.el = document.getElementById(elementId);
    document.addEventListener('mousemove', (e) => this.onMouseMove(e));
  }

  show(html: string): void {
    if (!this.el) return;
    this.el.innerHTML = html;
    this.el.classList.remove('hidden');
    this.visible = true;
  }

  hide(): void {
    if (!this.el) return;
    this.el.classList.add('hidden');
    this.visible = false;
  }

  attach(target: HTMLElement, contentFn: () => string): void {
    target.addEventListener('mouseenter', () => {
      this.show(contentFn());
    });
    target.addEventListener('mouseleave', () => {
      this.hide();
    });
  }

  private onMouseMove(e: MouseEvent): void {
    if (!this.el || !this.visible) return;
    const pad = 16;
    let x = e.clientX + pad;
    let y = e.clientY + pad;

    const rect = this.el.getBoundingClientRect();
    if (x + rect.width > window.innerWidth) {
      x = e.clientX - rect.width - pad;
    }
    if (y + rect.height > window.innerHeight) {
      y = e.clientY - rect.height - pad;
    }

    this.el.style.left = `${x}px`;
    this.el.style.top = `${y}px`;
  }
}
